module.exports = __webpack_public_path__ + "196ffbc1bfa06a3c27c7fe4c5544b48a.svg";